(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-lightbox"] && !Shopify.designMode) return;
  try {
    class CCLightbox extends HTMLElement {
  constructor() {
    super();
    this.images = [];
    this.currentIndex = 0;
    this.openedBy = null;
    this.onNavigateCallback = null;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.keyHandler = this.handleKeydown.bind(this);

    this.overlay = this.querySelector('.cc-lightbox__overlay');
    this.container = this.querySelector('.cc-lightbox__container');
    this.closeBtn = this.querySelector('.cc-lightbox__close');
    this.prevBtn = this.querySelector('.cc-lightbox__nav--prev');
    this.nextBtn = this.querySelector('.cc-lightbox__nav--next');
    this.imageEl = this.querySelector('.cc-lightbox__image');
    this.contentEl = this.querySelector('.cc-lightbox__content');

    this.bindEvents();
  }

  bindEvents() {
    this.closeBtn.addEventListener('click', () => this.hide());
    this.overlay.addEventListener('click', () => this.hide());
    this.prevBtn.addEventListener('click', () => this.navigate(-1));
    this.nextBtn.addEventListener('click', () => this.navigate(1));

    this.container.addEventListener('click', (e) => {
      if (e.target === this.container) this.hide();
    });

    this.contentEl.addEventListener('touchstart', (e) => {
      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
    }, { passive: true });

    this.contentEl.addEventListener('touchend', (e) => {
      var diffX = this.touchStartX - e.changedTouches[0].clientX;
      var diffY = this.touchStartY - e.changedTouches[0].clientY;
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
        this.navigate(diffX > 0 ? 1 : -1);
      }
    }, { passive: true });
  }

  handleKeydown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      this.hide();
    }
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      this.navigate(-1);
    }
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      this.navigate(1);
    }
  }

  show(opener, images, startIndex, onNavigate) {
    this.openedBy = opener;
    this.images = images || [];
    this.currentIndex = startIndex || 0;
    this.onNavigateCallback = onNavigate || null;

    if (this.images.length === 0) return;

    this.preloadImages();
    this.updateImage();
    this.updateNavButtons();

    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');

    document.addEventListener('keydown', this.keyHandler);

    if (typeof trapFocus === 'function') {
      trapFocus(this, this.closeBtn);
    }
    this.focus();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');

    document.removeEventListener('keydown', this.keyHandler);

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.openedBy);
    } else if (this.openedBy) {
      this.openedBy.focus();
    }
  }

  navigate(direction) {
    var newIndex = this.currentIndex + direction;
    if (newIndex < 0 || newIndex >= this.images.length) return;

    this.currentIndex = newIndex;
    this.preloadImages();
    this.updateImage();
    this.updateNavButtons();

    if (this.onNavigateCallback) {
      this.onNavigateCallback(this.currentIndex);
    }
  }

  preloadImages() {
    var indices = [this.currentIndex - 1, this.currentIndex + 1];
    for (var i = 0; i < indices.length; i++) {
      var idx = indices[i];
      if (idx >= 0 && idx < this.images.length && this.images[idx]) {
        var img = new Image();
        img.src = this.images[idx].src;
      }
    }
  }

  updateImage() {
    var img = this.images[this.currentIndex];
    if (!img) return;

    this.imageEl.src = img.src;
    this.imageEl.alt = img.alt || '';
  }

  updateNavButtons() {
    this.prevBtn.disabled = this.currentIndex === 0;
    this.nextBtn.disabled = this.currentIndex === this.images.length - 1;
  }
}

if (!customElements.get('cc-lightbox')) {
  customElements.define('cc-lightbox', CCLightbox);
}
  } catch(e) { console.error(e); }
})();

})();
